export default "__VITE_ASSET__27TSezfy__"